<mat-radio-group aria-label="Select an option" [formControl]="formControl">
  <div>
    <mat-radio-button class="mat-radio-lg" value="all">All</mat-radio-button>
  </div>
  <div>
    <mat-radio-button class="mat-radio-lg" value="true">Yes</mat-radio-button>
  </div>
  <div>
    <mat-radio-button class="mat-radio-lg" value="false">No</mat-radio-button>
  </div>
</mat-radio-group>
